import { ContainerBadgeComponent } from '@modules/common/components/container-badge/container-badge.component';
import { RailMenuComponent } from '@modules/common/components/rail-menu/rail-menu.component';
import { DetailBreadcrumbsComponent } from '@modules/common/components/detail-breadcrumbs/detail-breadcrumbs.component';
import { ItemReviewComponent } from '@modules/common/components/item-review/item-review.component';
import { TenancySelectorComponent } from '@modules/common/components/tenancy-selector/tenancy-selector.component';
import { ItemHandoverComponent } from '@modules/common/components/item-handover/item-handover.component';
import { CanPurgeTeamItemPipe } from '@modules/common/pipes/can-purge-team-item.pipe';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { StitchTimestampsComponent } from '@modules/common/components/stitch-timestamps/stitch-timestamps.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BundledInputsModule } from '@modules/bundled-inputs/bundled-inputs.module';
import { CommentsModule } from '@modules/comments/comments.module';
import { ListItemSeparatorComponent } from '@modules/common/components/list/list-items-separator/list-items-separator.component';
import { ListLoadErrorComponent } from '@modules/common/components/list/list-load-error/list-load-error.component';
import { NoContentStubComponent } from '@frontendlib/components/components/no-content-stub/no-content-stub.component';
import { LoadingIndicatorComponent } from '@frontendlib/components/components/loading-indicator/loading-indicator.component';
import { Button2Component } from '@frontendlib/components/components/button/button2.component';
import { IconComponent } from '@frontendlib/components/components/icon/icon.component';
import { ContextMenuDividerComponent } from '@frontendlib/components/features/popover/components/context-menu-divider/context-menu-divider.component';
import { ContextMenuHeadingComponent } from '@frontendlib/components/features/popover/components/context-menu-heading/context-menu-heading.component';
import { ContextMenuItemComponent } from '@frontendlib/components/features/popover/components/context-menu-item/context-menu-item.component';
import { ContextMenuStateIndicatorComponent } from '@frontendlib/components/features/popover/components/context-menu-state-indicator/context-menu-state-indicator.component';
import { PopoverDirective } from '@frontendlib/components/features/popover/directives/popover.directive';
import { Checkbox2Component } from '@frontendlib/components/controls/checkbox/checkbox2.component';
import { ListSelectionBarComponent } from '@modules/common/components/list/list-selection-bar/list-selection-bar.component';
import { Pagination2Component } from '@modules/common/components/pagination/pagination2.component';
import { SidebarItemComponent } from '@modules/common/components/sidebar-item/sidebar-item.component';
import { ConnectionsModule } from '@modules/connections/connections.module';
import { ContactsSideBarComponent } from '@modules/contacts/components/side-bar/side-bar.component';
import { TitleByContactsFilterPipe } from '@modules/contacts/pipes/title-by-contacts-filter.pipe';
import { DragNDropModule } from '@modules/drag-n-drop/drag-n-drop.module';
import { LinkedInfoListComponent } from '@modules/elements/components/link-info/linked-info-list/linked-info-list.component';
import { GroupQuickFormComponent } from '@modules/elements/components/quick-forms/group-quick-form/group-quick-form.component';
import { ContactContextMenuDirective } from '@modules/elements/directives/contact-context-menu.directive';
import { GroupContextMenuDirective } from '@modules/elements/directives/group-context-menu.directive';
import { QuickActionComponent } from '@modules/form-controls/components/quick-action/quick-action.component';
import { ItemDescriptionFieldComponent } from '@modules/common/components/item-description/item-description-field.component';
import { FormControlsModule } from '@modules/form-controls/form-controls.module';
import { MatIconModule } from '@angular/material/icon';
import { KnotsModule } from '@modules/knots/knots.module';
import { FormatParticipantPipe } from '@modules/messages/pipes/format-participant.pipe';
import { ScrollModule } from '@modules/scroll/scroll.module';
import { TagsModule } from '@modules/tags/tags.module';
import { ToArrayPipe } from '@modules/utils/pipes/array/to-array.pipe';
import { UtilsModule } from '@modules/utils/utils.module';
import { CommonModule as AppCommonModule } from '../common/common.module';
import { ElementsModule } from '../elements/elements.module';
import { ContactFormComponent } from './components/contact-form/contact-form.component';
import { ContactsListContextMenuComponent } from './components/contacts-list-context-menu/contacts-list-context-menu.component';
import { ContactsListComponent } from './components/contacts-list/contacts-list.component';
import { GroupFormComponent } from './components/group-form/group-form.component';
import { GroupSectionsComponent } from './components/group-sections/group-sections.component';
import { GroupsListContextMenuComponent } from './components/groups-list-context-menu/groups-list-context-menu.component';
import { GroupsListComponent } from './components/groups-list/groups-list.component';
import { ContactsListContainerComponent } from './components/list-container/list-container.component';
import { ContactsMainViewComponent } from './components/main-view/main-view.component';
import { SideBarGroupsTreeComponent } from './components/side-bar-groups-tree/side-bar-groups-tree.component';
import { SideBarGroupsComponent } from './components/side-bar-groups/side-bar-groups.component';
import { SidebarContextMenuComponent } from './components/sidebar-context-menu/sidebar-context-menu.component';
import { ContactsListContextMenuDirective } from './directives/contacts-list-context-menu.directive';
import { GroupsListContextMenuDirective } from './directives/groups-list-context-menu.directive';
import { SidebarContextMenuDirective } from './directives/sidebar-context-menu.directive';
import { EntityHubComponent } from '@modules/elements/components/entity-hub/entity-hub.component';
import { EntityHubSearchComponent } from '@modules/elements/components/entity-hub/entity-hub-search/entity-hub-search.component';
import { StitchHubComponent } from '@modules/elements/components/stitch-hub/stitch-hub.component';
import { FeatureUpsellComponent } from '@modules/common/components/feature-upsell/feature-upsell.component';

@NgModule({
  imports: [
    ContainerBadgeComponent,
    DetailBreadcrumbsComponent,
    ItemReviewComponent,
    TenancySelectorComponent,
    ItemHandoverComponent,
    CanPurgeTeamItemPipe,
    AppCommonModule,
    BundledInputsModule,
    CommentsModule,
    CommonModule,
    ConnectionsModule,
    DragNDropModule,
    ElementsModule,
    FormControlsModule,
    FormsModule,
    KnotsModule,
    MatIconModule,
    MatTooltipModule,
    ContextMenuDividerComponent,
    ContextMenuHeadingComponent,
    ContextMenuItemComponent,
    ContextMenuStateIndicatorComponent,
    PopoverDirective,
    ReactiveFormsModule,
    ScrollModule,
    ScrollingModule,
    TagsModule,
    UtilsModule,
    FormatParticipantPipe,
    ListLoadErrorComponent,
    NoContentStubComponent,
    LoadingIndicatorComponent,
    ListItemSeparatorComponent,
    ListSelectionBarComponent,
    Pagination2Component,
    QuickActionComponent,
    ToArrayPipe,
    ContactContextMenuDirective,
    GroupContextMenuDirective,
    LinkedInfoListComponent,
    GroupQuickFormComponent,
    SidebarItemComponent,
    EntityHubComponent,
    EntityHubSearchComponent,
    StitchHubComponent,
    FeatureUpsellComponent,
    ContactsListComponent,
    ItemDescriptionFieldComponent,
    Button2Component,
    IconComponent,
    StitchTimestampsComponent,
    Checkbox2Component,
    RailMenuComponent,
  ],
  declarations: [
    // Components
    ContactFormComponent,
    ContactsListContainerComponent,
    ContactsListContextMenuComponent,
    ContactsMainViewComponent,
    ContactsSideBarComponent,
    GroupFormComponent,
    GroupSectionsComponent,
    GroupsListComponent,
    GroupsListContextMenuComponent,
    SideBarGroupsComponent,
    SideBarGroupsTreeComponent,
    SidebarContextMenuComponent,

    // Directives
    ContactsListContextMenuDirective,
    GroupsListContextMenuDirective,
    SidebarContextMenuDirective,
    // Pipes
    TitleByContactsFilterPipe,
  ],
  exports: [
    ContactFormComponent,
    ContactsListComponent,
    ContactsListContainerComponent,
    ContactsMainViewComponent,
    ContactsSideBarComponent,
    GroupFormComponent,
    GroupsListComponent,
    // Directives
    ContactsListContextMenuDirective,
    GroupsListContextMenuDirective,
    TitleByContactsFilterPipe,
  ],
  providers: [FormatParticipantPipe],
})
export class ContactsModule {}
